import { render, staticRenderFns } from "./clues.vue?vue&type=template&id=9d5fe9d2&"
import script from "./clues.vue?vue&type=script&lang=js&"
export * from "./clues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d5fe9d2')) {
      api.createRecord('9d5fe9d2', component.options)
    } else {
      api.reload('9d5fe9d2', component.options)
    }
    module.hot.accept("./clues.vue?vue&type=template&id=9d5fe9d2&", function () {
      api.rerender('9d5fe9d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/lostAndFound/lostManagement/clues.vue"
export default component.exports